export default __webpack_public_path__ + "static/media/navbarlogo.8db0d5ca.svg";